import React from "react";
import "./TestPriceModal.css";

interface CheckoutModalProps {
  show: boolean;
  onClose: () => void;
  discounted_price: string;
  original_price: string;
  test_category_name: string;
  blogTitle: string;
  onCheckout: () => void;
}

const TestPriceModal: React.FC<CheckoutModalProps> = ({
  show,
  onClose,
  discounted_price,
  original_price,
  blogTitle,
  onCheckout,
}) => {
  if (!show) return null;

  const savings =
    Number(original_price) - Number(discounted_price);

  return (
    <div className="pricing-modal-overlay">
      <div className="pricing-modal">
        {/* Header */}
        <div className="pricing-modal-header">
          <h4>Unlock Test Series</h4>
          <button className="close-btn" onClick={onClose}>
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="pricing-modal-body">
          <h5 className="series-title">{blogTitle}</h5>

          {/* Price Box */}
          <div className="price-box">
            <div className="old-price">₹{original_price}</div>
            <div className="new-price">₹{discounted_price}</div>
            <div className="save-text">
              You save ₹{savings}
            </div>
          </div>

          {/* Benefits */}
          <div className="benefits-box">
            <div>✅ Full access to all mock tests for that Test Series</div>
            <div>✅ Unlimited validity</div>
            {/* <div>✅ Attempt tests multiple times</div> */}
            <div>✅ Instant access after payment</div>
          </div>
        </div>

        {/* Footer */}
        <div className="pricing-modal-footer">
          <button className="btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn-checkout"
            onClick={onCheckout}
          >
            Proceed to Checkout
          </button>
        </div>
      </div>
    </div>
  );
};

export default TestPriceModal;
